import React, { useContext } from "react";
import { ScreenContext } from "@foundation/screen";

import styles from "./userModulesTopicStories.module.css";
import { UserTopicsStoriesDesktop } from "~components/TopicModule/UserTopicsStoriesDesktop";
import { UserTopicsStoriesMobile } from "~components/TopicModule/UserTopicsStoriesMobile";

export default function UserModulesTopicStories() {
  const {
    breakpoints: { smallDesktop, largeDesktop },
  } = useContext(ScreenContext);
  const isMobileOrTablet = !smallDesktop && !largeDesktop;

  return (
    <div className={styles.UserModulesTopicStories}>
      <div className={styles.topicStoriesContainer}>
        {isMobileOrTablet ? (
          <UserTopicsStoriesMobile />
        ) : (
          <UserTopicsStoriesDesktop />
        )}
      </div>
    </div>
  );
}
